
import React, { useState } from 'react';

interface HeaderProps {
  logoUrl?: string;
}

const Header: React.FC<HeaderProps> = ({ logoUrl }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpandableMenu = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <div className="sandbox-header-top-wrapper">
        <nav className="sandbox-nav-main">
          <div className="nav-container">
            
            <div className="nav-logo-area">
              <a href="https://www.queenofclean.blog" className="logo-circle-wrapper">
                <img 
                  src={logoUrl || "https://images.squarespace-cdn.com/content/6962244a930d3931ee04d503/b6e3f7d7-2254-425b-b8bc-afb27d2d52db/Gemini_Generated_Image_32texm32texm32te.png?content-type=image%2Fpng"} 
                  alt="Lynsey Queen of Clean Logo" 
                  className={logoUrl ? "header-logo-custom" : "header-logo"}
                  // @ts-ignore
                  fetchPriority="high"
                />
              </a>
            </div>

            <div className="nav-and-social-group">
              
              <button className="menu-pill-toggle" onClick={toggleExpandableMenu}>
                <span id="menuText">{isExpanded ? 'Close' : 'Menu'}</span> 
                <i 
                  className="fa-solid fa-chevron-down" 
                  id="menuChevron" 
                  style={{ transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}
                ></i>
              </button>

              <ul className={`nav-links ${isExpanded ? 'expanded' : ''}`} id="expandableLinks">
                <li><a href="https://www.queenofclean.blog" className="nav-btn">Home</a></li>
                <li><a href="https://www.smallbizsupportsandbox.co.uk/cleaning-tips" className="nav-btn">Cleaning Tips</a></li>
                <li><a href="https://www.smallbizsupportsandbox.co.uk/laundry" className="nav-btn">Laundry Tips</a></li>
                <li><a href="https://www.smallbizsupportsandbox.co.uk/recipes" className="nav-btn">Recipes</a></li>
                <li><a href="https://www.smallbizsupportsandbox.co.uk/videos" className="nav-btn">Videos</a></li>
                <li><a href="https://www.smallbizsupportsandbox.co.uk/christmas" className="nav-btn">Christmas</a></li>
                <li><a href="https://www.queenofclean.blog/planners" className="nav-btn">Planners</a></li>
                <li><a href="https://lynsey-s-best-buys-443089853457.us-west1.run.app/" className="nav-btn">Store</a></li>
              </ul>

              <div className="social-wrapper">
                <div className="social-links">
                  <a href="https://www.facebook.com/lynseyqueenofclean" target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="Facebook">
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                  <a href="https://www.instagram.com/lynsey_queenofclean" target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="Instagram">
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                  <a href="https://www.amazon.co.uk/shop/lynsey_queenofclean" target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="Amazon">
                    <i className="fa-brands fa-amazon"></i>
                  </a>
                  <a href="https://www.tiktok.com/@lynsey_queenofclean" target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="TikTok">
                    <i className="fa-brands fa-tiktok"></i>
                  </a>
                  <a href="https://uk.pinterest.com/lynsey_queenofclean" target="_blank" rel="noopener noreferrer" className="social-btn" aria-label="Pinterest">
                    <i className="fa-brands fa-pinterest-p"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>

      <style>{`
        :root {
          --brand-bg: #F1B1BA; 
          --brand-dark-pink: #d18ba0;
          --btn-white: #ffffff;
          --text-btn: #000000;
          --transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          --header-bar-height: 220px;
          --nav-item-height: 42px;
        }

        header#header, .header, .header-announcement-bar-wrapper, #header-section {
          display: none !important;
        }

        .sandbox-header-top-wrapper {
          width: 100%;
          background-color: var(--brand-bg);
          position: relative;
          z-index: 9999;
          height: var(--header-bar-height);
          display: flex;
          align-items: center;
        }

        .sandbox-nav-main {
          width: 100%;
        }

        .nav-container {
          max-width: 1440px; 
          margin: 0 auto;
          display: flex;
          align-items: center;
          padding: 0 40px;
          width: 100%;
        }

        /* LOGO STYLING */
        .logo-circle-wrapper {
          display: flex;
          width: 170px;
          height: 170px;
          overflow: hidden;
          transition: all var(--transition);
          border-radius: 50%;
        }

        .logo-circle-wrapper:hover {
          transform: scale(1.06);
          box-shadow: 0 8px 25px rgba(0,0,0,0.15);
        }

        .header-logo {
          width: 170px !important;
          height: 170px !important;
          clip-path: circle(41.5% at 50% 50%);
          transform: scale(1.22);
          object-fit: cover;
        }

        .header-logo-custom {
          width: 170px !important;
          height: 170px !important;
          border-radius: 50%;
          object-fit: cover;
        }

        /* RIGHT ALIGNMENT LOGIC */
        .nav-and-social-group { 
          display: flex; 
          align-items: center; 
          gap: 20px;
          margin-left: auto; /* Pushes everything to the right */
        }

        .nav-links { 
          display: flex; 
          list-style: none; 
          margin: 0; 
          padding: 0; 
          gap: 8px;
        }
        
        .nav-btn {
          text-decoration: none !important;
          background-color: var(--btn-white);
          color: var(--text-btn) !important;
          padding: 0 18px;
          height: var(--nav-item-height);
          border-radius: 50px;
          font-size: 0.8rem;
          font-weight: 700;
          text-transform: uppercase;
          display: flex;
          align-items: center;
          transition: all var(--transition);
          white-space: nowrap;
        }

        .social-wrapper {
          padding-left: 20px;
          border-left: 2px solid rgba(255, 255, 255, 0.3);
          display: flex;
          align-items: center;
        }

        .social-links { display: flex; gap: 8px; }
        
        .social-btn {
          width: 38px;
          height: 38px;
          background-color: var(--btn-white);
          color: var(--text-btn) !important;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all var(--transition);
          text-decoration: none !important;
        }

        .nav-btn:hover, .social-btn:hover, .menu-pill-toggle:hover {
          transform: translateY(-2px);
          background-color: var(--brand-dark-pink);
          color: var(--btn-white) !important;
        }

        /* MOBILE MENU TOGGLE HIDDEN ON DESKTOP */
        .menu-pill-toggle {
          display: none;
          background-color: var(--btn-white);
          color: var(--text-btn);
          border: none;
          padding: 0 30px;
          height: 45px;
          border-radius: 50px;
          font-weight: 800;
          text-transform: uppercase;
          cursor: pointer;
          align-items: center;
          gap: 10px;
          font-size: 0.9rem;
          transition: all var(--transition);
        }

        /* MOBILE CENTERING AND ALIGNMENT */
        @media (max-width: 1024px) {
          .sandbox-header-top-wrapper {
            height: auto !important;
            padding: 40px 0 !important;
          }
          .nav-container {
            flex-direction: column !important;
            gap: 25px;
            text-align: center;
          }
          .nav-and-social-group {
            flex-direction: column !important;
            width: 100%;
            gap: 20px;
            margin-left: 0; /* Centered on mobile */
          }
          .logo-circle-wrapper { width: 140px; height: 140px; margin: 0 auto; }
          .header-logo { width: 140px !important; height: 140px !important; }

          /* Expandable Logic */
          .menu-pill-toggle { display: flex; margin: 0 auto; }
          .nav-links {
            display: none; 
            flex-direction: column;
            width: 100%;
            gap: 12px;
          }
          .nav-links.expanded { display: flex; }
          .nav-btn { width: 220px; margin: 0 auto; }

          .social-wrapper {
            border-left: none;
            padding-left: 0;
            justify-content: center;
            margin-top: 10px;
          }
        }
      `}</style>
    </>
  );
};

export default Header;
